export enum IdentityConfigConversationCaptureTarget {
  vendor = 'vendor',
}
